export default "__VITE_ASSET__B4e83Qen__"